import { useTranslation } from "react-i18next";
import { getStatusClasses, getStatusChipStyleVars, getStatusLabel } from "../../helpers/StatusMapper";

const ConnectorStatusBadge = ({ status }) => {
    const { t } = useTranslation();

    return (
        <span className={getStatusClasses(status)} style={getStatusChipStyleVars(status)}>
            {getStatusLabel(status, t)}
        </span>
    );
};

export default ConnectorStatusBadge;
